import { termsConditions } from 'lib/constants/termsAndConditions';
import { Action } from 'modules/types/common';
import { identifyUser } from 'store/analytics/actions';
import { getTPSAuthStatus } from 'store/authentication/actions';
import { LoginType } from 'store/authentication/types';
import { getProfile } from 'store/profile/actions';
import { RootDispatch, Thunk } from 'store/types';
import { pipeWithError } from 'store/utils';

export const RESET_METADATA = 'GLOBAL.RESET_METADATA';

export const GET_TERMS_AND_CONDITIONS = 'GLOBAL.GET_TERMS_AND_CONDITIONS';
export const GET_TERMS_AND_CONDITIONS_SUCCESS = 'GLOBAL.GET_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_TERMS_AND_CONDITIONS_FAIL = 'GLOBAL.GET_TERMS_AND_CONDITIONS_FAIL';

export const SET_TEMPORARY_TC = 'GLOBAL.SET_TEMPORARY_TC';

export const getTermsAndConditions = () => (dispatch: RootDispatch) => {
  dispatch({ type: GET_TERMS_AND_CONDITIONS });
  dispatch({ type: GET_TERMS_AND_CONDITIONS_SUCCESS, payload: { data: termsConditions } });
};
// TODO: https://jira.co.ihc.com/browse/DFD-16779
// ({
//   type: GET_TERMS_AND_CONDITIONS,
//   payload: {
//     client: 'appSettings',
//     request: {
//       url: '/terms',
//       headers: {
//         settingskey: Config.APP_SETTINGS_KEY
//       }
//     }
//   }
// });

export const setAcceptTemporaryTC = (type: string) => ({
  type: SET_TEMPORARY_TC,
  payload: type
});

/**
 * Allows resetting metadata
 * example being: fromRoutes for flows
 */
export const resetMetadata = () => ({
  type: RESET_METADATA
});

export const GET_DEPS = '[Global] Fetch App Dependencies Start';
export const GET_DEPS_ERROR = '[Global] Fetch App Dependencies Fail';
export const GET_DEPS_SUCCESS = '[Global] Fetch App Dependencies Success';
export const getDependencies = (): Thunk => dispatch =>
  pipeWithError(
    dispatch,
    [getProfile(), getTPSAuthStatus(), getTermsAndConditions(), identifyUser()],
    GET_DEPS,
    GET_DEPS_ERROR,
    GET_DEPS_SUCCESS
  );

export const INITIAL_NAVIGATION_COMPLETE = '[Global] Initial Navigation Complete';
export const setInitialNavigationComplete = () => ({
  type: INITIAL_NAVIGATION_COMPLETE
});

export const SET_NAVIGATION_AFTER_AUTHENTICATION = '[Global] SET_NAVIGATION_AFTER_AUTHENTICATION';
export const SET_NAVIGATION_PARAM_AFTER_AUTHENTICATION =
  '[Global] SET_NAVIGATION_PARAM_AFTER_AUTHENTICATION';

export const setNavigationPathAfterAuthentication = (routeName: string) => ({
  type: SET_NAVIGATION_AFTER_AUTHENTICATION,
  payload: routeName
});

export const setNavigationParamAfterAuthentication = (routeParam: string) => ({
  type: SET_NAVIGATION_PARAM_AFTER_AUTHENTICATION,
  payload: routeParam
});

export const MY_HEALTH_STATUS = '[Global] MY_HEALTH_STATUS';
export const MY_HEALTH_STATUS_FAIL = '[Global] MY_HEALTH_STATUS_FAIL';
export const MY_HEALTH_STATUS_SUCCESS = '[Global] MY_HEALTH_STATUS_SUCCESS';

export const getAppHealth = (): Action => ({
  type: MY_HEALTH_STATUS,
  payload: {
    client: 'mhpStatus',
    request: {
      method: 'get',
      url: '/api/v2/summary.json'
    }
  }
});

export const SET_LOGIN_TYPE = '[Global] SET_LOGIN_TYPE';
export const setLoginType = (type: LoginType) => ({
  type: SET_LOGIN_TYPE,
  payload: type
});
